module.exports = __webpack_public_path__ + "static/media/shoppingBag.8f666664.svg";